import { Store } from "vuex";
import { AdobePageLoadEvent } from "./adobe-page-load";
import { AppState } from "@/store";
import { ServicesContainer } from "@/services";
import { WebPageDetails } from "../models";

export class AdobeAlternatePickupConfirmationEvent extends AdobePageLoadEvent {
  constructor(event: AdobeAlternatePickupConfirmationEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    Object.assign(this.web.webPageDetails, {
      name: `order:checkout:select-alternate-location-complete`,
      pageViews: {
        value: 1,
      },
      pageType: 'checkout',
      siteSection: 'cart',
    } as WebPageDetails);

    Object.assign(this.commerce, {
      alternateLocationComplete: { value: 1 }
    })
  }
}